import { render } from "./GenericH4.vue?vue&type=template&id=7951c413&scoped=true"
const script = {}

import "./GenericH4.vue?vue&type=style&index=0&id=7951c413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7951c413"]])

export default __exports__